import router from 'src/router'
export const estaNaTelaVerificarFolhas = () => {
  return router.currentRoute.value?.name === 'verifyTimesheet'
}

export const deveUsarApisDepreciadasDaFolha = () => {
  return estaNaTelaVerificarFolhas()
}
